"use strict";

import Util from "/js/util/util.js";
import AppUtil from "/js/util/app-util.js";
import Global from "/js/core/global.js";
import InteractionResultUtil from "/js/util/interaction-result-util.js";
import FocusUtil from '/js/util/focus-util.js';

/**
 * Displays the results at the end of an interaction.
 * Not to be confused with `ResponseView`.
 * Is instantiated once-per-interaction; its DOM element is reused, however.
 */
export default class ResultView {

  #$el = $("#result");
  #$title = this.#$el.find("#resultTitle");
  #$subtitle = this.#$el.find("#resultSubtitle");
  #$content = this.#$el.find("#resultContent");
  #$doneButton = this.#$el.find("#resultButton");
  #interactionObject = null;

  constructor() { 
    this.#$doneButton.on("click tap", e => this.#onDoneButton(e));
    FocusUtil.doStandardTreatment(this.#$doneButton);
  }

  get $el() {
    return this.#$el;
  }

  resize() { }

  show(interactionObject, answers) {
    this.#interactionObject = interactionObject;
    const resultObject = this.#interactionObject.result;

    // cl('InteractionResultView.show()', resultObject, answers);

    // Fade in just this caption text (looks better)
    AppUtil.setCssWithoutTransition(this.#$title, () => this.#$title.css("opacity", 0));
    setTimeout(() => this.#$title.css("opacity", 1), 1);

    this.#$title.text(resultObject.title);

    let output = InteractionResultUtil.findCorrectOutput(answers, resultObject, interactionObject.questions);
    if (!output) {
      clw("WARNING: no output found.");
    } else {
      this.#populate(answers, output);
    }

    // Update done button.
    this.#$doneButton.text(resultObject.continueText);

    document.activeElement.blur();

    this.resize();

    Util.windowUnselect();

    AppUtil.animInFromBottom(this.#$el, null,
        () => Util.flashMacScrollbar($("#resultOuter")));
  }

  hide(callback) {
    AppUtil.animOutToTop(this.#$el, null, callback);
  }

  /** 
   * Populate the view using the given `output` object.
   */
  #populate(answers, output) {

    this.#$content.empty();
    this.#$content.removeClass("isHtml");

    if (!output) {
      // Shouldn't happen.
      callback();
      return;
    }
    this.#$subtitle.text(output.subtitle || "");

    switch (output.type) {
      case "html":
        this.#populateHtml(answers, output);
        break;
      case "plain":
      default:
        this.#populatePlain(answers, output);
        break;
    }
  }

  #populateHtml(answers, output) {
    const onComplete = (html) => {
      const $html = $(html);
      this.#$content.addClass("isHtml");
      this.#$content.append($html);
      this.#$content.show();
    };
    this.#$content.hide();
    InteractionResultUtil.stringReplaceHtmlAsync(this.#interactionObject, output, answers, onComplete);
  }

  #populatePlain(answers, output) {
    let string;
    if (!output) {
      string = "";
    } else if (!output.resource) {
      string = "";
    } else {
      string = output.resource;
    }
    // The text can include hard returns, so reformat them.
    string = string.replace("\n", "<br><br>");  // TODO: needs "/g"
    this.#$content.append(string);
  }

  #onDoneButton(e) {
    if (Global.cmsDevJson) {
      AppUtil.sendCloseToParentWindow();
      return;
    }
    this.#$el.trigger("interaction-done", this.#interactionObject.interactionId);
  }
}
